import React, {useEffect, useState} from 'react';
import {Button, Paper, Tabs} from "@mui/material";
import Box from "@mui/material/Box";
import JobMetricCutting from "../../../../../API/material-cloud/common/JobMetricCutting";
import JobMetricEdge from "../../../../../API/material-cloud/common/JobMetricEdge";
import JobMetricMilling from "../../../../../API/material-cloud/common/JobMetricMilling";
import JobMetricDrilling from "../../../../../API/material-cloud/common/JobMetricDrilling";
import JobMetricPacking from "../../../../../API/material-cloud/common/JobMetricPacking";
import JobMetricOrganizationTable from "../../prodaction/jobmetricorganization/JobMetricOrganizationTable";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import MaterialService from "../../../../../API/material-cloud/admin/AdminMaterialMaterialCloudService";
import {ButtonGroupTabBar} from "../../../button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import {withFilter} from "../../../../../data/FilterTables/withFilterHOC";
import {JobMetricOrganizationFilterData} from "../../../../../data/FilterTables/JobMetricOrganizationFilterData";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import {orderJobType} from "../../../../../data/OrderJobType";

const ComponentWithFilter = withFilter(JobMetricOrganizationTable, JobMetricOrganizationFilterData);

const JobMetricCloudModul = (
    {
        id,
        handleModalAlert,
        notAuthorized,
        isAdmin,
        cloudModuleFromHeader,
        readOnly,
        typeMaterial
    }) => {
    const isPieceMaterial = typeMaterial === "PIECE"
    const isSlabMaterial = typeMaterial === "SLAB"
    const isLinearMaterial = typeMaterial === "LINEAR"


    const [tab, setTab] = useState("0");
    const [dataJobMetric, setDataJobMetric] = useState({
        "0": {type: "CUT", data: [], typeList: []},
        "1": {type: "MILLING", data: [], typeList: []},
        "2": {type: "EDGE", data: [], typeList: []},
        "3": {type: "DRILLING", data: [], typeList: []},
        "4": {type: "PACKAGING", data: [], typeList: []},
    });

    const [rowSelection, setRowSelection] = useState([]);
    const [openSelection, setOpenSelection] = useState(false)

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState, currTab) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`/all-materials/jobs+${tab}`, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = (values) => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = isPieceMaterial ? "4" : pagesData["/all-materials/jobs"]?.tab
        savedTab && setTab(savedTab)
        getTabsData(savedTab)
        setTableOptions((prev) => ({
            ...prev,
            totalElements: values[savedTab]?.data.length
        }))
    }
    useEffect(() => {
        if (isPieceMaterial) {
            JobMetricPacking.getJobMetricPackingByMaterialId(id)
                .then(function (response) {
                    setDataJobMetric({
                        "0": {type: "CUT", data: [], typeList: []},
                        "1": {type: "MILLING", data: [], typeList: []},
                        "2": {type: "EDGE", data: [], typeList: []},
                        "3": {type: "DRILLING", data: [], typeList: []},
                        "4": {
                            type: "PACKAGING",
                            data: response.data,
                            typeList: OrderUtil.getListFieldByEnum(response.data, 'orderJobType', orderJobType)
                        },
                    })
                    getStartPageSize([[], [], [], [], response])
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        } else {
            Promise.all([JobMetricCutting.getJobMetricCuttingByMaterialId(id), JobMetricMilling.getJobMetricMillingByMaterialId(id), JobMetricEdge.getJobMetricEdgeByMaterialId(id), JobMetricDrilling.getJobMetricDrillingByMaterialId(id), JobMetricPacking.getJobMetricPackingByMaterialId(id)]).then((values) => {
                setDataJobMetric({
                    "0": {
                        type: "CUT",
                        data: values[0]?.data,
                        typeList: OrderUtil.getListFieldByEnum(values[0]?.data, 'orderJobType', orderJobType)
                    },
                    "1": {
                        type: "MILLING",
                        data: values[1]?.data,
                        typeList: OrderUtil.getListFieldByEnum(values[1]?.data, 'orderJobType', orderJobType)
                    },
                    "2": {
                        type: "EDGE",
                        data: values[2]?.data,
                        typeList: OrderUtil.getListFieldByEnum(values[2]?.data, 'orderJobType', orderJobType)
                    },
                    "3": {
                        type: "DRILLING",
                        data: values[3]?.data,
                        typeList: OrderUtil.getListFieldByEnum(values[3]?.data, 'orderJobType', orderJobType)
                    },
                    "4": {
                        type: "PACKAGING",
                        data: values[4]?.data,
                        typeList: OrderUtil.getListFieldByEnum(values[4]?.data, 'orderJobType', orderJobType)
                    },
                })
                getStartPageSize(values)

            }).catch(function (error) {
                handleModalAlert(error);
            });
        }

    }, []);

    const handleDeleteJob = () => {
        MaterialService.deleteJobMetric(id, {"ids": rowSelection}, dataJobMetric[tab].type).then(function (response) {
            const newJobMetricData = dataJobMetric[tab].data.filter(el => !rowSelection.includes(el.id))
            const newJobMetric = Object.fromEntries(Object.entries(dataJobMetric).map(([key, value]) => {
                return key === tab ? [key,
                    {
                        ...value,
                        data: newJobMetricData
                    }
                ] : [key, value]
            }))
            setDataJobMetric(newJobMetric)
            tableOptionsHandle((prev) => ({
                ...prev,
                totalElements: dataJobMetric[tab]?.data.length - rowSelection.length
            }))
            setOpenSelection(false)
            setRowSelection([])
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }
    const handleAddJob = (data) => {
        setDataJobMetric(prev => ({...prev, [tab]: {...prev[tab], data}}))
    }

    const handleSelectAction = () => {
        handleDeleteJob()
    }
    const modalActions = [
        {name: "Удалить работу", type: "delete"},
    ]
    const getTabsData = (tab, start) => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`/all-materials/jobs+${tab}`]?.pageSize

        const totalElements = dataJobMetric[tab]?.data?.length

        setTableOptions((prev) => ({
            ...prev,
            pageSize: pageSize || 20,
            totalElements: start ? tableOptions?.totalElements : totalElements
        }))
    }

    const handleChangeTab = (tab) => {
        setTab(tab)
        getTabsData(tab)
        EditLocalStoragePagesData(`/all-materials/jobs`, "tab", tab)
    }
    const renderContent = () => {
        switch (tab) {
            case "0":
                return <ComponentWithFilter
                    id={id}
                    data={dataJobMetric["0"]?.data}
                    type={dataJobMetric["0"]?.type}
                    setData={handleAddJob}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    isChooseSignJob={false}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    columnAdded={false}
                    rowActions={false}
                    handleModalAlert={handleModalAlert}
                    itemId={"listJobCutting"}
                    enableRowSelection={true}
                    fullWidth={true}
                    addJob={true}
                    notAuthorized={notAuthorized}
                    isUnit={true}
                    cloudModuleFromHeader={cloudModuleFromHeader}
                    admin={isAdmin}
                    readOnly={readOnly}
                    typeList={dataJobMetric["0"]?.typeList}
                />
            case "1":
                return <ComponentWithFilter
                    id={id}
                    data={dataJobMetric["1"]?.data}
                    type={dataJobMetric["1"]?.type}
                    setData={handleAddJob}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    isChooseSignJob={false}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    columnAdded={false}
                    rowActions={false}
                    handleModalAlert={handleModalAlert}
                    itemId={"listJobMilling"}
                    enableRowSelection={true}
                    fullWidth={true}
                    addJob={true}
                    notAuthorized={notAuthorized}
                    isUnit={true}
                    cloudModuleFromHeader={cloudModuleFromHeader}
                    admin={isAdmin}
                    readOnly={readOnly}
                    typeList={dataJobMetric["1"]?.typeList}
                />
            case "2":
                return <ComponentWithFilter
                    id={id}
                    data={dataJobMetric["2"]?.data}
                    type={dataJobMetric["2"]?.type}
                    setData={handleAddJob}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    isChooseSignJob={false}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    columnAdded={false}
                    rowActions={false}
                    handleModalAlert={handleModalAlert}
                    itemId={"listJobEdge"}
                    enableRowSelection={true}
                    fullWidth={true}
                    addJob={true}
                    notAuthorized={notAuthorized}
                    cloudModuleFromHeader={cloudModuleFromHeader}
                    admin={isAdmin}
                    readOnly={readOnly}
                    typeList={dataJobMetric["2"]?.typeList}
                />
            case "3":
                return <ComponentWithFilter
                    id={id}
                    data={dataJobMetric["3"]?.data}
                    type={dataJobMetric["3"]?.type}
                    setData={handleAddJob}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    isChooseSignJob={false}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    columnAdded={false}
                    rowActions={false}
                    handleModalAlert={handleModalAlert}
                    itemId={"listJobDrilling"}
                    enableRowSelection={true}
                    fullWidth={true}
                    addJob={true}
                    notAuthorized={notAuthorized}
                    isUnit={true}
                    cloudModuleFromHeader={cloudModuleFromHeader}
                    admin={isAdmin}
                    readOnly={readOnly}
                    typeList={dataJobMetric["3"]?.typeList}
                />
            case "4":
                return <ComponentWithFilter
                    id={id}
                    data={dataJobMetric["4"]?.data}
                    type={dataJobMetric["4"]?.type}
                    setData={handleAddJob}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    isChooseSignJob={false}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    columnAdded={false}
                    rowActions={false}
                    handleModalAlert={handleModalAlert}
                    itemId={"listJobPacking"}
                    enableRowSelection={true}
                    fullWidth={true}
                    addJob={true}
                    notAuthorized={notAuthorized}
                    isUnit={true}
                    cloudModuleFromHeader={cloudModuleFromHeader}
                    admin={isAdmin}
                    readOnly={readOnly}
                    typeList={dataJobMetric["4"]?.typeList}
                />
        }
    }
    return (
        <div>
            {<Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Box sx={{
                    flexGrow: 1, display: "flex",
                    flexDirection: "column", gap: "20px"
                }}>
                    <ButtonGroupTabBar activeTab={tab}>
                        <Button tabIndex={"0"} disabled={isPieceMaterial || isLinearMaterial}
                                onClick={(e) => handleChangeTab("0")}>
                            <CheckIcon/>Раскрой
                        </Button>
                        <Button tabIndex={'1'} disabled={isPieceMaterial || isLinearMaterial}
                                onClick={(e) => handleChangeTab('1')}>
                            <CheckIcon/>Фрезерование
                        </Button>
                        <Button tabIndex={'2'} disabled={isPieceMaterial || isSlabMaterial}
                                onClick={(e) => handleChangeTab('2')}>
                            <CheckIcon/>Кромление
                        </Button>
                        <Button tabIndex={'3'} disabled={isPieceMaterial || isLinearMaterial}
                                onClick={(e) => handleChangeTab('3')}>
                            <CheckIcon/>Сверление
                        </Button>
                        <Button tabIndex={'4'} disabled={isLinearMaterial} onClick={(e) => handleChangeTab('4')}>
                            <CheckIcon/>Упаковка
                        </Button>
                    </ButtonGroupTabBar>
                    {renderContent()}
                </Box>
            </Box>}
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpenSelection(true)}/>
            </Paper>}
            <ModalSelectAction
                open={openSelection}
                reset={() => setOpenSelection(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
            />
        </div>
    );
};

export default JobMetricCloudModul;